<template>
  <Modal v-bind="$attrs" v-on="$listeners">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12">
          <SfHeading
            :title="vehicleDetailsTitle"
            :description="vehicle.Vin ? `VIN: ${vehicle.Vin}` : ''"
            :level="3"
            class="sf-heading--left"
          />
        </div>
        <div class="col-xs-12 vehilce-short-info">

          <span>{{ vehicle.VehicleInfo.marke }} </span>
          <span>{{ vehicle.VehicleInfo.baureihe }} </span>
          <span>{{ vehicle.VehicleInfo.verkaufsbezeichnung }} </span>
          <span>{{ vehicle.VehicleInfo.motor }} </span>
          <span>{{ vehicle.VehicleInfo.produktionsdatum }} </span> <br />
          <span>{{ $t("Paint") }}: {{ vehicle.VehicleData.lackCode }} </span>
          <span>{{ $t("Pad") }}: {{ vehicle.VehicleData.polsterCode }} </span>

          <div class="technical-campaigns m-tb-10" v-if="hasCampaigns">
            <SfIcon class="info-icon" icon="info_circle" size="16px" color="red-primary" /> {{ }}
            {{ $t("Attention! - Check Technical Campaigns") }}
          </div>

          {{ $t("karosserie") }}: {{ vehicle.VehicleInfo.karosserie }} /
          {{ $t("katalogausfuehrung") }}: {{ vehicle.VehicleInfo.katalogausfuehrung }} <br />
          {{ $t("typschluesselList") }}: {{ vehicle.VehicleInfo.typschluesselList[0] }} /
          {{ $t("getriebeart") }}: {{ vehicle.VehicleInfo.getriebeart }} <br />
          {{ $t("lenkungsart") }}: {{ vehicle.VehicleInfo.lenkungsart }} /
          {{ $t("produktionsdatum") }}: {{ vehicle.VehicleInfo.produktionsdatum }} <br />
          {{ $t("lack") }}: {{ vehicle.VehicleData.lack }} / {{ $t("polster") }}:
          {{ vehicle.VehicleData.polster }}

        </div>
        <div class="col-xs-12">
          <SfTabs :open-tab="openTab">
            <SfTab v-for="tab in vehicleTabs" :key="tab.title" :title="$t(tab.title)">
              <div v-for="(table, index) in tab.tables" :key="index">
                <SfHeading
                  v-if="table.title"
                  :title="$t(table.title)"
                  :level="4"
                  class="m-tb-15 sf-heading--left"
                />
                <div v-if="!table.tableRows.length">
                  {{ $t("No Data") }}
                </div>
                <SfTable v-else>
                  <SfTableHeading>
                    <SfTableHeader v-for="header in table.tableHeaders" :key="header">
                      {{ $t(header) }}
                    </SfTableHeader>
                  </SfTableHeading>
                  <SfTableRow v-for="(row, key) in table.tableRows" :key="key">
                    <SfTableData v-for="data in row" :key="formatValue(data.value)">
                    <span :class="{mark: data.mark}">{{ formatValue(data.value) }}</span>
                    </SfTableData>
                  </SfTableRow>
                </SfTable>
              </div>
            </SfTab>
          </SfTabs>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal } from '@/modules/core';
import { mapGetters } from 'vuex';
import {
  SfHeading, SfTabs, SfTable, SfIcon,
} from '@storefront-ui/vue';

export default {
  name: 'VehicleModal',
  components: {
    Modal,
    SfHeading,
    SfTabs,
    SfIcon,
    SfTable,
  },
  data() {
    return {
      openTab: 1,
    };
  },
  computed: {
    hasCampaigns() {
      const { TechnicalCampaigns = [] } = this.vehicle;
      return TechnicalCampaigns.length;
    },
    ...mapGetters({
      vehicle: 'level4/vehicleData',
      vehicleTabs: 'level4/vehicleTabs',
    }),
    vehicleDetailsTitle() {
      return this.$t('vehicle details');
    },
  },
  methods: {
    formatValue(value) {
      if (typeof value === 'boolean') {
        return value ? this.$t('Yes') : this.$t('No');
      }

      return Array.isArray(value) ? value.join(', ') : this.$t(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint";

.sf-modal {
  --modal-width: auto;
}

.sf-tabs {
  margin: var(--spacer-sm) 0;
}

.mark {
  color: var(--c-primary)
}

p {
  font-family: var(--font-family-secondary);
  line-height: 1.2;
}

.technical-campaigns {
  color: var(--c-danger);
}

.info-icon {
  display: inline-block;
  position: relative;
  top: 3px;
}

.vehilce-short-info {
  margin: var(--spacer-sm) 0;
  font-size: var(--font-sm);
}
</style>
